<template>
  <section class="seguros-beneficios">
    <DsTextSplit
      as="h3"
      base="¿Qué sucede después de"
      highlight="enviar tu solicitud?"
      baseColor="var(--ds-purple-900)"
      highlightColor="var(--ds-purple-400)"
    />
     <article v-for="stage in stages" :key="stage.number" class="proceso__stage-card">
        <div class="proceso__stage proceso__stage--compact">
          <div class="proceso__number">{{ stage.number }}</div>
          <div class="proceso__stage-copy">
            <DsText as="subtitle7" color="var(--ds-secondary-main)" >{{ stage.title }}</DsText>
            <DsText as="body3" class="proceso__stage-desc">{{ stage.description }}</DsText>
          </div>
        </div>
      </article>

  </section>
</template>

<script setup lang="ts">

import DsTextSplit from '../atoms/DsTextSplit.vue'
import DsText from '../atoms/DsText.vue'
const stages = [
  {
    number: 1,
    title: 'Reporte recibido',
    description: 'Confirmaremos que tu solicitud fue recibida.',
  },
  {
    number: 2,
    title: 'Revisión documental ',
    description: 'Validaremos que tu expediente esté completo.',
  },
  {
    number: 3,
    title: 'Evaluación de la aseguradora ',
    description: 'La aseguradora analizará la reclamación y las condiciones de la cobertura.',
  },
  {
    number: 4,
    title: 'Resolución ',
    description: 'Te informaremos el resultado y los siguientes pasos.',
  },
]
</script>

<style scoped>
.seguros-beneficios {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 962px;
  padding: 24px 16px;
  overflow: hidden;
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 24px;
}


.seguros-beneficios__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.proceso__stage {
  display: flex;
  align-items: center;
  gap: 16px;
}

.proceso__stage-copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.proceso__number {
  width: 35px;
  height: 35px;
  min-width: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background:  var(--ds-purple-900);
  color: var(--ds-grey-50);
  font-family: var(--ds-font-family-base);
  font-size: 22px;
  font-weight: 600;
  align-self: center;
}

@media (max-width: 767px) {
  .seguros-beneficios { border-radius: 16px; gap: 24px; padding: 24px 16px; }
  .proceso__stage { gap: 16px; align-items: center; }
  .proceso__number {
    width: 24px;
    height: 24px;
    min-width: 24px;
    font-size: 14px;
    line-height: 20px;
  }
  .proceso__stage-copy { gap: 8px; }
  .proceso__stage-desc { line-height: 24px; }
}

@media (min-width: 600px) and (max-width: 767px) {
  .seguros-beneficios { padding: 24px; }
}
</style>
